import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const PageShell = ({
  title,
  eyebrow = "Employee workspace",
  description,
  backTo = "/",
  actions,
  children,
  className = "",
}) => (
  <section className={`portal-page-shell ${className}`.trim()}>
    <header className="portal-page-header">
      <div className="portal-page-header__main">
        {backTo && (
          <Link
            to={backTo}
            className="portal-page-header__back"
            aria-label="Back"
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
          </Link>
        )}
        <div>
          <span className="portal-page-header__eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
      </div>
      {actions && <div className="portal-page-header__actions">{actions}</div>}
    </header>
    <div className="portal-page-body">{children}</div>
  </section>
);

export const EmptyState = ({ icon = "fa-inbox", title, description, action }) => (
  <div className="portal-empty-state">
    <span className="portal-empty-state__icon" aria-hidden="true">
      <i className={`fas ${icon}`} />
    </span>
    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {action && <div>{action}</div>}
  </div>
);

export default PageShell;
